function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ffa700",
  d: "M5 42.05c-.55 8.79 22.23 32.67 33.76 32.67a5.6 5.6 0 004.12-1.65l1.64-1.65a4 4 0 000-5.76l-6.31-6.31a4 4 0 00-5.77 0l-3.29 4.11A31.53 31.53 0 0122 58.25a20 20 0 01-5-6.86l3.57-3.57a4 4 0 000-5.77l-6.31-6.31a4.55 4.55 0 00-5.76 0l-1.62 1.65A6 6 0 005 42.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#dae5ec",
  d: "M66.44 5h-25.8a5.22 5.22 0 00-5.22 5.22v36l9.06-9.06h25.25A5.21 5.21 0 0075 31.9V8a3 3 0 00-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a2b9c3",
  d: "M64.79 14.44H45.85a.73.73 0 01-.82-.82.73.73 0 01.82-.82h18.94a.73.73 0 01.83.82.87.87 0 01-.83.82m0 7.69H45.85a.83.83 0 010-1.65h18.94a.74.74 0 01.83.83 1.24 1.24 0 01-.83.82m0 7.41H45.85a.83.83 0 010-1.65h18.94a.74.74 0 01.83.83.87.87 0 01-.83.82"
}));